import { EntityBase, ModelBase } from "app/shared"

export enum ActivityVariantStatus {
    Published = 1,
    Canceled = 2
}

export interface IActivityVariant extends ModelBase {
    activityId: string
    adminTitle: string
    artists: IActivityVariantArtist[]
    endDate: string
    id?: string
    isCreateOtherLanguage?: boolean
    language: string
    order: number
    placeId: string
    publish: boolean
    relationId?: string
    startDate: string
    title: string
    variantStatus: ActivityVariantStatus
}

export interface ActivityVariantEntity extends EntityBase {
    activityId: string
    adminTitle: string
    artists: IActivityVariantArtist[]
    endDate?: string
    id?: string
    isCreateOtherLanguage?: boolean
    isWebPublish: boolean
    language: string
    languageRelationId?: string
    order: number
    placeId: string
    startDate: string
    title: string
    variantStatus: ActivityVariantStatus
}

export interface IActivityVariantArtist {
    id: string;
    title?: string
    roleId: string
}